import React from "react";
import { GlobalStyles } from "@mui/material";
import FormBuilder from "../FormBuilder/FormBuilder";
import { Element, Errors } from "../../../Interface/scheduler/form";
import { useFormConfigContext } from "../../contexts/FormConfigContext";
import { AppConstants, conceptIDs } from "../../../constants/constant";
import { useFormContext } from "../../contexts/FormContext";

export const globalStyles = (
  <GlobalStyles
    styles={(theme) => ({
      ".contact-us-section p a": {
        color: theme.palette.primary.main,
      },
    })}
  />
);

export const fspStyles = (
  <GlobalStyles
    styles={(theme) => ({
      ".contact-us-section p a": {
        color: theme.typography.body1.fspLinks,
      },
    })}
  />
);

export const RenderFormElement: React.FC<{
  element: Element;
  errors: Errors;
  setErrors: React.Dispatch<React.SetStateAction<Errors>>;
  disabled?: boolean;
}> = ({ element, errors, setErrors, disabled = false }) => {
  const { formConfig } = useFormConfigContext();
  const { formValues } = useFormContext();
  const hideTerms =
    sessionStorage.getItem("countryCode") === AppConstants.COUNTRY_CA;
  return (
    <div className={element.type} key={element.type}>
      {element?.requiredtext && (
        <label className="required-text">{element?.requiredtext}</label>
      )}
      {element.fields?.map((field) => (
        <FormBuilder
          key={field.id}
          field={field}
          errors={errors}
          setErrors={setErrors}
          disabled={disabled}
        />
      ))}
      {element.terms && !formValues.hideOptinTerms && !hideTerms && (
        <>
          {formConfig.conceptid === conceptIDs.FSP_CONCEPT_ID
            ? fspStyles
            : globalStyles}
        </>
      )}
    </div>
  );
};
